const getHtml = () => {
  return `
    <div class="alert alert-dark" role="alert">
      This is a default alert.
    </div>
  `;
};

const getCss = () => {
  return ``;
};

const getJs = () => {
  return ``;
};

const DefaultAlert = { getHtml, getCss, getJs };

export default DefaultAlert;
